import { useQuery } from '@tanstack/react-query'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { api } from '../lib/api'
import { fmtDate, type AdminUser, type PageMeta } from '../lib/types'
import { StatusBadge } from '../components/StatusBadge'

export function UsersPage() {
  const [params, setParams] = useSearchParams()
  const nav = useNavigate()
  const q = params.get('q') || ''
  const account_type = params.get('account_type') || ''
  const identity_status = params.get('identity_status') || ''
  const blocked = params.get('blocked') || ''
  const page = Number(params.get('page') || 1)

  const qs = new URLSearchParams()
  qs.set('page', String(page))
  if (q) qs.set('q', q)
  if (account_type) qs.set('account_type', account_type)
  if (identity_status) qs.set('identity_status', identity_status)
  if (blocked) qs.set('blocked', blocked)

  const { data, isLoading } = useQuery({
    queryKey: ['users', qs.toString()],
    queryFn: () => api<{ items: AdminUser[]; meta: PageMeta }>(`/admin/users?${qs}`),
  })

  function set(key: string, value: string) {
    const next = new URLSearchParams(params)
    if (value) next.set(key, value); else next.delete(key)
    if (key !== 'page') next.delete('page')
    setParams(next)
  }

  return (
    <div>
      <h1 className="page-title">Пользователи</h1>
      <p className="page-sub">Поиск, фильтры и карточка пользователя</p>
      <div className="toolbar">
        <input className="input" placeholder="Имя, email, телефон, ID" value={q} onChange={(e) => set('q', e.target.value)} />
        <select className="select" value={account_type} onChange={(e) => set('account_type', e.target.value)}>
          <option value="">Все типы</option>
          <option value="customer">Заказчик</option>
          <option value="executor">Исполнитель</option>
        </select>
        <select className="select" value={identity_status} onChange={(e) => set('identity_status', e.target.value)}>
          <option value="">Верификация: все</option>
          <option value="none">Нет</option>
          <option value="pending">Ожидает</option>
          <option value="approved">Одобрено</option>
          <option value="rejected">Отклонено</option>
        </select>
        <select className="select" value={blocked} onChange={(e) => set('blocked', e.target.value)}>
          <option value="">Статус: все</option>
          <option value="false">Активные</option>
          <option value="true">Заблокированные</option>
        </select>
      </div>
      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th>Имя</th>
              <th>Email</th>
              <th>Тип</th>
              <th>Верификация</th>
              <th>Рейтинг</th>
              <th>Регистрация</th>
              <th>Статус</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && <tr><td colSpan={7}>Загрузка…</td></tr>}
            {data?.items.map((u) => (
              <tr key={u.id} onClick={() => nav(`/users/${u.id}`)}>
                <td>{u.name}</td>
                <td>{u.email || '—'}</td>
                <td><StatusBadge value={u.account_type} label={u.account_type === 'customer' ? 'Заказчик' : 'Исполнитель'} /></td>
                <td><StatusBadge value={u.identity_status} /></td>
                <td>{u.rating_avg} ({u.rating_count})</td>
                <td>{fmtDate(u.created_at)}</td>
                <td>{u.is_blocked ? <StatusBadge value="blocked" label="Заблокирован" /> : <StatusBadge value="approved" label="Активен" />}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {data && (
        <div className="pager">
          <button className="btn" disabled={page <= 1} onClick={() => set('page', String(page - 1))}>Назад</button>
          <span className="muted">Стр. {data.meta.page} · всего {data.meta.total}</span>
          <button className="btn" disabled={!data.meta.has_next} onClick={() => set('page', String(page + 1))}>Далее</button>
        </div>
      )}
    </div>
  )
}
